/* unplugin-vue-components disabled */var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[
    // Duplicate sizing classes to maintain element size while loading
    { 'w-5 h-5': _vm.props.size === 'sm' },
    { 'w-6 h-6': _vm.props.size === 'base' },
    { 'w-7 h-7': _vm.props.size === 'lg' },
    // Custom sizing classes
    _vm.props.size.length > 3 ? _vm.props.size : '',
    // Classes set on component
    _vm.data.staticClass ]},[_c('span',{class:[
      ("iconify icon:" + (_vm.props.icon)),
      { 'w-5 h-5': _vm.props.size === 'sm' },
      { 'w-6 h-6': _vm.props.size === 'base' },
      { 'w-7 h-7': _vm.props.size === 'lg' },
      // Custom sizing classes
      _vm.props.size.length > 3 ? _vm.props.size : '' ],attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }